module.exports = __webpack_public_path__ + "img/partai.270217e0.png";